import { styled } from "styled-components";

import {
    BackgroundFieldValue,
    colorCSS,
    cssColorsFromBackgroundField,
    radius
} from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const AccordionButton = styled.button`
    ${redundantCssFromKebab("background", "inherit")}
    ${redundantCssFromKebab("color", "inherit")}
    ${redundantCssFromKebab("margin", "0")}
    ${redundantCssFromKebab("padding", "0")}
    ${redundantCssFromKebab("border", "none")}
`;

export const GridItem = styled.div<{ backgroundField: BackgroundFieldValue }>`
    ${({ backgroundField }: { backgroundField: BackgroundFieldValue }) =>
        cssColorsFromBackgroundField(backgroundField)}
    ${redundantCssFromKebab("border-radius", `${radius.medium}`)}
    ${redundantCssFromKebab("min-height", "6.05rem")}
    ${redundantCssFromKebab("padding", "0.9rem 1.25rem 1.15rem 2.5rem")}

    > h3 {
        ${redundantCssFromKebab("margin", "0")}

        button {
            ${redundantCssFromKebab("font-weight", "inherit")}
            ${redundantCssFromKebab("position", "relative")}
            ${redundantCssFromKebab("text-align", "left")}

            span {
                ${redundantCssFromKebab("position", "absolute")}
                ${redundantCssFromKebab("left", "-1.25rem")}
            }
        }
    }
`;

export const GridItemContent = styled.div`
    ${redundantCssFromKebab("font-size", "90%")}
    ${redundantCssFromKebab("padding", "0.5rem 0")}

    ul {
        ${redundantCssFromKebab("margin", "0.5rem 0")}
        ${redundantCssFromKebab("padding-left", "1.5rem")}
    }

    li {
        ${redundantCssFromKebab("margin", "0.25rem 0")}
    }

    > *:last-child {
        ${redundantCssFromKebab("margin-bottom", "0")}
    }
`;

export const List = styled.div`
    ${redundantCssFromKebab("text-align", "left")}
`;

export const ListItem = styled.div`
    ${redundantCssFromKebab("border-bottom", `0.5px solid ${colorCSS("N50")}`)}
    ${redundantCssFromKebab("padding", "1rem 0")}

    > h3 {
        ${redundantCssFromKebab("margin", "0")}

        button {
            ${redundantCssFromKebab("cursor", "pointer")}
            ${redundantCssFromKebab("font-weight", "inherit")}
            ${redundantCssFromKebab("padding", "0 1.25rem")}
            ${redundantCssFromKebab("position", "relative")}
            ${redundantCssFromKebab("text-align", "left")}

            span {
                ${redundantCssFromKebab("left", "0")}
                ${redundantCssFromKebab("position", "absolute")}
            }
        }
    }

    &:first-child {
        ${redundantCssFromKebab("padding-top", "0")}
    }

    &:last-child {
        ${redundantCssFromKebab("border-bottom", "0")}
        ${redundantCssFromKebab("padding-bottom", "0")}
    }
`;

export const ListItemContent = styled.div`
    ${redundantCssFromKebab("font-size", "90%")}
    ${redundantCssFromKebab("padding", "1rem 1.25rem")}
    img {
        ${redundantCssFromKebab("clear", "right")}
        ${redundantCssFromKebab("float", "right")}
        ${redundantCssFromKebab("margin", "0 0 1rem 1rem")}
        ${redundantCssFromKebab("max-height", "250px")}
        ${redundantCssFromKebab("max-width", "250px")}
        /* uncomment when lightbox is supported
  &:hover {
    ${redundantCssFromKebab("box-shadow", "1px 1px 4px 0 rgba(0, 0, 0, 0.25)")}
    ${redundantCssFromKebab("cursor", "pointer")}
  }
  */
    }
    table {
        ${redundantCssFromKebab("width", "100%")}
        th {
            ${redundantCssFromKebab(
                "border-bottom",
                `1px solid ${colorCSS("N40")}`
            )}
            ${redundantCssFromKebab("padding", "0.3rem")}
        }
        td {
            ${redundantCssFromKebab(
                "border-top",
                `1px solid ${colorCSS("N40")}`
            )}
            ${redundantCssFromKebab("padding", "0.3rem")}
        }
    }
    ul {
        ${redundantCssFromKebab("margin", "0.5rem 0")}
        ${redundantCssFromKebab("padding-left", "1.5rem")}
    }
    li {
        ${redundantCssFromKebab("margin", "0.25rem 0")}
    }
    > *:last-child {
        ${redundantCssFromKebab("margin-bottom", "0")}
    }
`;
